import React from 'react'
import { Link } from 'react-router-dom'
import '../style/NotFound.scss'

function NotFound() {
    return (
        <div className="notFound">
            <h1>404</h1>
            <h3>Pagina non trovata</h3>
            <Link to="/enrica">Torna alla pagina principale</Link>
        </div>
    )
}

export default NotFound
